import { LngLat } from "mapbox-gl";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useLeadStore } from "../..";
import useProperty from "../../hooks/useProperty";
import PropertySummary from "../property/PropertySummary";

function LeadDetailsPropertyTab() {
    const { id } = useParams();
    const leadStore = useLeadStore();
    const lead = useMemo(() => computed(() => leadStore.leads.find(l => l.id.toString() === id)!), [id]).get();
    const coordinate = useMemo(() => new LngLat(lead.centerPoint.longitude, lead.centerPoint.latitude), [lead]);
    const { property } = useProperty(coordinate);

    if (!property)
        return null;

    return <PropertySummary property={property} />;
}

export default observer(LeadDetailsPropertyTab);
